import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, ref } from 'vue'
import { useCommon } from '@y/composables'


export default /*@__PURE__*/_defineComponent({
  __name: 'Task',
  setup(__props) {

const {
  fns: { handleGetToken, handleGetLanguage },
} = useCommon()

const visible = ref(false)
const authorization = ref('')

onBeforeMount(() => {
  authorization.value = handleGetToken()
})

return (_ctx: any,_cache: any) => {
  const _component_app_task_center = _resolveComponent("app-task-center")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "c_flex c_cursor",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("span", null, "任务中心", -1)
    ])),
    _createVNode(_component_app_task_center, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      authorization: authorization.value,
      headers: {
      'Accept-language': _unref(handleGetLanguage)(),
    }
    }, null, 8, ["modelValue", "authorization", "headers"])
  ], 64))
}
}

})